<template>
  <header class="flex items-center justify-between gap-4">
    <span class="font-size-5 font-500 line-height-8 tracking-[0.25px]">{{
      translations?.title || t('canvasUI.collectionSelector.title')
    }}</span>

    <CButton v-if="!hideClose" class="rounded h-11 w-11" @click="emit('close')">
      <template #icon>
        <CIcon icon="close" size="16" />
      </template>
    </CButton>
  </header>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { useAppStore } from '@collection-selector/stores/app.store'

defineProps<{
  hideClose?: boolean
}>()

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()

const { translations } = useAppStore()
</script>
